import { Loader2 } from "lucide-react";

interface LoadingStateProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  showSpinner?: boolean;
  fullScreen?: boolean;
}

export function LoadingState({ 
  message = "Loading...", 
  size = 'medium', 
  showSpinner = true,
  fullScreen = false
}: LoadingStateProps) {
  const spinnerSizes = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  const textSizes = {
    small: 'text-sm',
    medium: 'text-lg',
    large: 'text-xl'
  };

  const containerClasses = fullScreen 
    ? 'fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50' 
    : 'flex items-center justify-center w-full py-10';

  return (
    <div className={containerClasses}>
      <div className="flex flex-col items-center gap-4 text-center">
        {showSpinner && (
          <div className="relative">
            <Loader2 className={`${spinnerSizes[size]} animate-spin text-primary`} />
            <div className="absolute -inset-1 rounded-full opacity-30 animate-pulse bg-primary blur-md"></div>
          </div>
        )}
        {message && (
          <p className={`${textSizes[size]} font-medium text-foreground animate-pulse`}>
            {message}
          </p>
        )}
      </div>
    </div>
  );
}